/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupnoquestions2Inputs */

const en_signupnoquestions2 = /** @type {(inputs: Signupnoquestions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No questions yet. Name and email are always asked.`)
};

const de_signupnoquestions2 = /** @type {(inputs: Signupnoquestions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Fragen. Name und E-Mail werden immer abgefragt.`)
};

/**
* | output |
* | --- |
* | "No questions yet. Name and email are always asked." |
*
* @param {Signupnoquestions2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupnoquestions2 = /** @type {((inputs?: Signupnoquestions2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupnoquestions2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupnoquestions2(inputs)
	return de_signupnoquestions2(inputs)
});
export { signupnoquestions2 as "signupNoQuestions" }